import { Currency } from '@/core/currency/interfaces';

const GYD: Currency = {
    name: 'Guyanese Dollar',
    demonym: 'Guyanese',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '328',
    symbol: 'G$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'GYD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default GYD;
